const BooleanIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M16.3188 9C16.3188 12.87 13.1888 16 9.31885 16C8.99885 16 8.68885 15.98 8.38885 15.93C4.95885 15.48 2.31885 12.55 2.31885 9C2.31885 5.13 5.44885 2 9.31885 2C12.8688 2 15.7988 4.64 16.2488 8.07C16.2988 8.37 16.3188 8.68 16.3188 9Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3189 15.0003C22.3189 18.8703 19.1889 22.0003 15.3189 22.0003C11.7689 22.0003 8.83892 19.3603 8.38892 15.9303C8.68892 15.9803 8.99892 16.0003 9.31892 16.0003C13.1889 16.0003 16.3189 12.8703 16.3189 9.00031C16.3189 8.68031 16.2989 8.37031 16.2489 8.07031C19.6789 8.52031 22.3189 11.4503 22.3189 15.0003Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4688 14.1201L19.8295 19.5061"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.858 16.5239L16.3188 11"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.8223 21.4324L11.3188 16"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default BooleanIcon;
